module.exports = __webpack_public_path__ + "img/Newbie_Dagger_02_Classic.63c3ce84.png";